import { render, staticRenderFns } from "./LoadoutSlot.vue?vue&type=template&id=541170b2&scoped=true&"
import script from "./LoadoutSlot.vue?vue&type=script&lang=ts&"
export * from "./LoadoutSlot.vue?vue&type=script&lang=ts&"
import style0 from "./LoadoutSlot.vue?vue&type=style&index=0&id=541170b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541170b2",
  null
  
)

export default component.exports